import React, { useState } from 'react';

const GmailReplyCollapse = ({ content, className }) => {
  const [isExpanded, setIsExpanded] = useState(false);

  // Check if content has the specific blockquote
  const blockquoteMarker = '<blockquote id="blockquote_zmail"';
  
  if (content && content.includes(blockquoteMarker)) {
    const splitIndex = content.indexOf(blockquoteMarker);
    const firstPart = content.substring(0, splitIndex);
    const blockquotePart = content.substring(splitIndex);

    return (
      <div className={`gmail-reply-container ${className || ''}`}>
        <div 
          className="note-text-main"
          dangerouslySetInnerHTML={{ __html: firstPart }}
        />
        <div 
          className="gmail-style-toggle" 
          onClick={() => setIsExpanded(!isExpanded)} 
          style={{ 
            cursor: 'pointer', 
            display: 'inline-flex',
            alignItems: 'center',
            background: '#eeeeee',
            borderRadius: '4px',
            padding: '2px 10px',
            margin: '5px 0',
            fontSize: '14px',
            color: '#444',
            userSelect: 'none',
            border: '1px solid #ddd',
            width: 'fit-content'
          }}
          title={isExpanded ? "Hide expanded content" : "Show expanded content"}
        >
          <span style={{ fontSize: '18px', lineHeight: '14px', marginBottom: '8px', fontWeight: 'bold' }}>...</span>
        </div>
        {isExpanded && (
          <div 
            className="note-text-expanded"
            dangerouslySetInnerHTML={{ __html: blockquotePart }}
          />
        )}
      </div>
    );
  }

  return (
    <div 
      className={className || "note-text"}
      dangerouslySetInnerHTML={{ __html: content }}
    />
  );
};

export default GmailReplyCollapse;
